import type { AccountRelatedRow } from '~/services/ContractingService';

import type { AccountCase } from './types';

export function toAccountCase(row: AccountRelatedRow<'cases'>): AccountCase {
  return {
    id: row.external_refs.salesforce,
    caseNumber: row.case_number,
    contactName: row.contact?.name ?? null,
    subject: row.subject,
    priority: row.priority,
    createdDate: row.created_at,
    status: row.status,
  };
}
